















import Markdown from '@/components/markdown.vue';
import '@/styles/github-markdown.less';
import {Component, Vue} from 'vue-property-decorator';
import md from '../documents/change-log/index.md';
import VersionMap from '../documents/change-log/map.json';

Vue.component('Markdown', Markdown);
@Component({
  name: 'Home'
})
export default class Home extends Vue {

  public components = [];
  public content: any = md;

  public created() {
    Object.keys(VersionMap).forEach(version => {
      import(`../documents/change-log/${version}.md`).then(comp => {
        this.components.push(Object.assign({
          name: version,
          source: comp.default
        }, VersionMap[version]));
      });
    });
  }
}
